import { Slider } from "@material-ui/core"
import { styled } from "@material-ui/styles"

export const CustomSlider = styled(Slider)(() => ({
    color: "#3a8589",
    padding: "13px 0",
    "& .MuiSlider-thumb": {
        height: 27,
        width: 27,
        color: "#fff",
        backgroundColor: "#f95936",
        border: "1px solid #fff",
        borderRadius: 5,
        fontWeight: "bold",
        fontSize: 15,
        minWidth: 60,
        textAlign: "center",
        marginTop: -12,
        "&:hover": {
            boxShadow: "0 0 0 8px rgba(249, 89, 54, 0.16)"
        }
    },
    "& .MuiSlider-track": {
        color: "#f95936",
        height: 12,
        marginTop: -4
    },
    "& .MuiSlider-rail": {
        color: "#C6C6E1",
        height: 6,
        opacity: 1
    }
}))
